import { receivableInvoicesApiNamespace } from 'receivable-invoices-js/constants/hosts';
import { qontoClient } from 'receivable-invoices-js/react/utils/api-clients/qonto';
import { camelizeKeys } from 'receivable-invoices-js/react/utils/camelize-keys';
import { fetchClientPortal } from './fetch-client-portal';

vi.mock('@repo/design-system-kit', () => ({
  useToast: vi.fn(() => ({
    showToast: vi.fn(),
  })),
}));

vi.mock('receivable-invoices-js/react/utils/api-clients/qonto');
vi.mock('receivable-invoices-js/constants/hosts', () => ({
  receivableInvoicesApiNamespace: '/api/v5',
}));

describe('unit | API | queries | fetch-client-portal', () => {
  const mockQontoClient = vi.mocked(qontoClient);
  const clientId = 'client-123';
  const URL = `${receivableInvoicesApiNamespace}/receivable_invoices/client_portals/shared`;

  beforeEach(() => {
    vi.clearAllMocks();
  });

  describe(fetchClientPortal, () => {
    it('fetches client portal successfully', async () => {
      const apiResponse = {
        data: {
          type: 'client_portals',
          attributes: {
            organization: {
              legal_name: 'string',
              legal_number: 'string',
              avatar_url: 'string',
              color_theme: 'string',
            },
            client: {
              company_name: 'string',
              first_name: 'string',
            },
          },
        },
      };
      const { data } = apiResponse;

      mockQontoClient.mockResolvedValue(apiResponse);

      const result = await fetchClientPortal({ clientId }, {});

      expect(mockQontoClient).toHaveBeenCalledWith(`${URL}/${clientId}`);
      expect(result).toStrictEqual(camelizeKeys(data.attributes));
    });

    it('handles API errors with custom error handler', async () => {
      const error = new Error('API Error');
      mockQontoClient.mockRejectedValue(error);

      const onError = vi.fn<(err: unknown) => void>();
      await fetchClientPortal({ clientId }, { onError });

      expect(onError).toHaveBeenCalledWith(error);
    });

    it('throws error when no error handler is provided', async () => {
      const error = new Error('API Error');
      mockQontoClient.mockRejectedValue(error);

      await expect(fetchClientPortal({ clientId }, {})).rejects.toThrow('API Error');
    });
  });
});
